import React from "react";
import "./Div1.css";

export const Div1 = () => {
  return (
    <div className="asb-div1">
      <div className="asb-div1-top">
        <div className="asb-div1-left">
          <div className="asb-div1-img-container">
            <img src="" alt="" />
          </div>
        </div>
        <div className="asb-div1-right">
          <p>
            The life and work of Prof. Samanta has been the subject of a number
            of films, documentaries, television series, talk shows, advocacy and
            awareness films, magazines and news items of all leading print and
            electronic media worldwide. His contribution has been recognised
            through several prestigious national and international awards. Some
            of these include:
          </p>
        </div>
      </div>
      <div className="asb-div1-bottom">
        <div className="asb-div1-left">
          <p>
            The life and work of Prof. Samanta has been the subject of a number
            of films, documentaries, television series, talk shows, advocacy and
            awareness films, magazines and news items of all leading print and
            electronic media worldwide. His contribution has been recognised
            through several prestigious national and international awards. Some
            of these include:
          </p>
        </div>
        <div className="asb-div1-right">
          <div className="asb-div1-img-container">
            <img src="" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
